export default __webpack_public_path__ + "static/media/logo.6211e645.svg";